import { TImageField, TLinkField } from '../../../types/types';
import { THeaderFields, THeaderProps, TLanguageOption } from '../types/lightHeader.types';

export class LightHeaderModel {
  public readonly fields: THeaderFields;

  constructor(props: THeaderProps) {
    this.fields = props?.fields;
  }

  get logoImage(): TImageField | undefined {
    return this.fields?.logoImage;
  }

  get mobileLogoImage(): TImageField | undefined {
    return this.fields?.mobileLogoImage;
  }

  get logoLink(): TLinkField | undefined {
    return this.fields?.logolink;
  }

  get items(): TLanguageOption[] {
    return this.fields?.items && Array.isArray(this.fields?.items) ? this.fields.items : [];
  }
}
